import { getRequest } from 'features/common/api/requests'
import { encodeUriParams } from 'features/common/utils/searchParamsUtils'
import { DataExplorerResource, DataExplorerTable, DataTreeResourceRequestProps } from 'features/new-data-explorer/types'
import settings from 'settings'

const BASE_URL = settings.workspaceApiUrl
export const PAGE_SIZE = 30

export const getResources = async ({
  connectionId,
  fqn,
  page = 1,
  search,
  searchFqnExact = undefined
}: DataTreeResourceRequestProps): Promise<DataExplorerResource> => {
  const resources = await getRequest(
    `${BASE_URL}/connections/${connectionId}/resources/${fqn || ''}?${encodeUriParams({
      pageSize: PAGE_SIZE,
      page,
      search,
      searchFqnExact
    })}`
  )
  return resources
}

export const getDataExplorerObject = async ({
  link,
  signal
}: {
  link: string
  signal?: AbortSignal
}): Promise<DataExplorerTable | null> => {
  if (!link) {
    return null
  }
  const { workspaceApiUrl } = settings
  const resource: DataExplorerTable = await getRequest(`${workspaceApiUrl}${link}`, { signal })
  return resource
}
